import React from 'react';
import './RemovalPrompt.css';

const RemovalPrompt = ({ onConfirm, onCancel }) => {
  return (
    <div className="removal-prompt">
      <div className="removal-content">
        <h3>REMOVAL PROMPT</h3>
        <p>
          You are about to delete an employee
          <br />from your dealership listing.
          <br /><br />
          Do you wish to continue?
        </p>
        <div className="removal-buttons">
          <button className="yes-button" onClick={onConfirm}>
            YES
          </button>
          <button className="no-button" onClick={onCancel}>
            NO
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemovalPrompt;
